import React, {useState} from 'react';
import SelectedImagePreview from 'views/product/SelectedImagePreview';

import {Img} from 'views/AppElements';

const ImgLoader = ({text}) => {

    return <React.Fragment>
        <span style={{fontSize: '1.5em'}}>{text}</span>
        <i className="fa fa-spinner fa-spin" aria-hidden="true" style={{fontSize: '1.5em'}}></i>
    </React.Fragment>
};

const PhotoFrameImg = ({id, className, imgUrl, imgFile, matting, style, borderColor, onImgLoad}) => {
    const [loadingImg, setLoadingImg] = useState(true);//the actual image object

    const mattingClassName = matting? matting+"Matting": ' ';
    const loadingClassName = loadingImg? "frameImgLoader": "";
    const borderClassName = borderColor? borderColor: "blackBorder";
    return <div className={"framePreviewContainer "+mattingClassName + " "+loadingClassName+" "+borderClassName}>
                {
                    loadingImg &&
                    <ImgLoader text={imgUrl? "Loading...": "Uploading..."} />
                }
                {
                    imgFile && 
                    <SelectedImagePreview id={id} style={style} 
                        className={"imgPreview "+className} file={imgFile} 
                        onImgLoad={(img) => {
                            setLoadingImg(false);

                            if(typeof onImgLoad === 'function')
                                onImgLoad(img);
                        }} />
                }

                {
                   imgUrl &&
                    <Img id={id} src={imgUrl} alt={id+"-photo-frame-img"}  style={style} className={className}
                            onImgLoad={(img) => {
                                setLoadingImg(false);

                                if(typeof onImgLoad === 'function')
                                    onImgLoad(img);
                            }}/>
                }
                
        </div>
}

export default PhotoFrameImg;


// WEBPACK FOOTER //
// ./src/views/order/PhotoFrameImg.js